import { OrthoJob } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateOrthoJobArgs,
    getDefaultOrthoJobCreateArgs,
    UpdateOrthoJobArgs,
} from "@nova/serializer/src/client/validators/jobs/ortho"
import { selectActivatedFireId } from "features/map/control/selectors"
import { selectActiveWorkspace } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectUserEmail, selectUserLicense } from "user/profile/selectors"
import { addEntitySocket } from "features/entity-caching/project/slice"

const {
    create: createOrthoJob,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    OrthoJob, // entity type
    CreateOrthoJobArgs, // create args to send to server
    ["processingMode"], // create args required by action
    UpdateOrthoJobArgs, // update args
    { flightId: string; imageCount?: number }, // input context
    {
        flightId: string
        projectId: string
        orgId: string
        userEmail: string
        queue: "premium"
        portfolioName: string
        licenseId: string
        imageCount?: number
    } // server context
>("OrthoJob")

export const addOrthoJobsToBuilder = (builder: Builder) =>
    builder.addCase(createAction, (store, { payload: { data, context } }, socket) => {
        const state = store.getState()
        const { flightId, imageCount } = context
        const projectId = selectActivatedFireId(state)!
        const org = selectActiveWorkspace()(state)!
        const userEmail = selectUserEmail(state)!
        const license = selectUserLicense(state)

        createOrthoJob(socket, data, {
            flightId,
            projectId,
            orgId: org.id,
            userEmail,
            portfolioName: org.name,
            licenseId: license?.licenseId ?? "",
            queue: "premium",
            imageCount,
        })
        store.dispatch(
            addEntitySocket({
                data: { ...getDefaultOrthoJobCreateArgs(), ...data, resourceName: "mock" },
                path: ["orthoFlights", { id: flightId }, "job"],
            })
        )
    })
export {
    createAction as createOrthoJob,
    updateAction as updateOrthoJob,
    deleteAction as deleteOrthoJob,
}
